import { createAsyncThunk } from '@reduxjs/toolkit';
import type { CreateAsyncThunkFunction } from '@reduxjs/toolkit';
import type { AppDispatch, ExtraArgument, RootState } from '..';

type AppThunkConfig = {
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: string;
  extra: ExtraArgument;
};

export const createAppAsyncThunk: CreateAsyncThunkFunction<AppThunkConfig> =
  createAsyncThunk.withTypes<AppThunkConfig>();
